import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Badge } from 'reactstrap'
import { Divider, Empty, Popconfirm, Table, Tooltip, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import EditAgentModal from './EditAgentModal'

import { updateAgent } from '../services'
import { handleError, number } from '../../../helpers'

export default function AgentsTable({ agents, reload }) {	
	const currentUser = useSelector(state => state.auth.user)
	const [editAgent, setEditAgent] = useState(null)

	const columns = [
		{
			title: 'Nombre Completo',
			dataIndex: 'name',
		},
		{
			title: 'Documento',
			dataIndex: 'document',
		},
		{
			title: 'Rol',
			render: t => 'Asesor Virtual'
		},
		{
			title: 'Fecha Vinculación',
			dataIndex: 'created_at',
		},
		{
			title: 'Total Conversaciones',
			dataIndex: 'conversations_count',
			render: t => `${number(t)} conversaciones`
		},
		{
			title: 'Estado',
			dataIndex: 'status',
			render: (t,r) => (
				<React.Fragment>
					<Badge color={t.color}>{t.label}</Badge>
				</React.Fragment>
			)
		},
		{
			title: 'Acciones',
			render: (t, r) => (
				<React.Fragment>
					{ currentUser.role === 'admin' && (
						<React.Fragment>
							<Tooltip title="Actualizar" className='text-link' onClick={() => setEditAgent(r)}>
								<FontAwesomeIcon icon={faEdit} />{" "}
								Editar
							</Tooltip>
							<Divider type="vertical" />
							{ !r.disabled_at ? (
								<Popconfirm
									title="¿Desea desactivar acceso del asesor virtual?"
									okText="Desactivar"
									cancelText="Cancelar"
									okButtonProps={{ danger:true }}
									onConfirm={() => handleToggle(r)}
								>
									<Tooltip title="Desactivar" className='text-link'>
										<FontAwesomeIcon icon={faToggleOn} />{" "}
										Desactivar
									</Tooltip>
								</Popconfirm>
							) : (
								<Popconfirm
									title="¿Desea activar acceso del asesor virtual?"
									okText="Activar"
									cancelText="Cancelar"
									okButtonProps={{ danger:true }}
									onConfirm={() => handleToggle(r)}
								>
									<Tooltip title="Activar" className='text-link'>
										<FontAwesomeIcon icon={faToggleOff} />{" "}
										Activar
									</Tooltip>
								</Popconfirm>
							)}
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	const handleToggle = agent => {
		updateAgent(agent.id, {
			disabled_at: agent.disabled_at ? '' : moment().format('YYYY-MM-DD HH:mm:ss')
		})
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}
	
	return (
		<React.Fragment>
			<Table 
				dataSource={agents}
				rowKey={r => r.id}
				columns={columns}
				loading={!agents}
				size="small"
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						imageStyle={{ height: '80px' }}
					/> 
				)}}
			/>
			{ editAgent && (
				<EditAgentModal 
					visible
					onClose={() => setEditAgent(null)}
					agent={editAgent}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}